import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Paper, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentsType } from 'v2-types/order';
import { FileData } from '../AutoRow/components/FileData';

type Props = {
  document: DocumentsType,
  handleDownload: (link: string, fileName: string) => void,
  viewFile: (fileId: string) => void,
  editTemplate: () => void,
  onDeleteDocument: () => void,
  onRequestSignature: (fileSource: string) => void
}

export const TemplateRow: React.FC<Props> = ({
  document: { _id: documentId, description, archives, data },
  handleDownload,
  viewFile,
  editTemplate,
  onDeleteDocument,
  onRequestSignature
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const files = archives.length > 0
    ? archives[0].files
    : null;

  return (
    <Paper elevation={2} key={documentId}>
      <Box
        style={{
          backgroundColor: "#f8fafb",
          minHeight: theme.spacing(6),
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid lightgray",
          justifyContent: "space-between",
          flexWrap: 'wrap',
          padding: theme.spacing(0.5, 1, 0.5, 3),
          gap: theme.spacing(0.5)
        }}
      >
        <Typography variant="body1" color="primary" style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{description}</Typography>
        <Box style={{ display: "flex", gap: theme.spacing(0.5), marginLeft: 'auto' }}>
          <Tooltip title={t('documents:editTemplateData')}>
            <IconButton
              size="small"
              style={{ padding: isMobile ? theme.spacing(1.5) : undefined }}
              onClick={editTemplate}
            >
              <FontAwesomeIcon icon="edit" />
            </IconButton>
          </Tooltip>
          <IconButton
            size="small"
            style={{ padding: isMobile ? theme.spacing(1.5) : undefined }}
            onClick={onDeleteDocument}
          >
            <FontAwesomeIcon icon="trash" />
          </IconButton>
        </Box>
      </Box>
      {files && (
        <Box style={{ padding: "0rem 1rem 0rem 1rem" }}>
          {files.map((file, index) => (
            <FileData
              showBorderBottom={files.length > 0}
              file={file}
              viewFile={viewFile}
              handleDownload={handleDownload}
              onRequestSignature={onRequestSignature}
            />
          ))}
        </Box>
      )}
    </Paper>
  );
};
